module.exports = __webpack_public_path__ + "static/media/qrcode.2bd8cdb1.png";